var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.6666 10.9173C13.4259 10.6774 13.0046 10.6774 12.7036 10.9173L10.8379 12.7769C8.43044 11.3372 6.5045 9.47768 5.24059 7.19824L7.10636 5.33869C7.3471 5.09875 7.3471 4.67885 7.10636 4.37893L3.0739 0.179956C2.95353 0.0599853 2.83316 0 2.6526 0C2.41186 0 2.29148 0.0599853 2.11093 0.179956C1.68963 0.659838 1.3887 0.89978 0.786837 1.55962C-3.66692 5.99853 12.0416 21.6547 16.4954 17.2158C17.0972 16.6159 17.3981 16.316 17.8194 15.8961C17.9398 15.7761 18 15.5962 18 15.4162C18 15.2363 17.9398 15.0563 17.8194 14.9363L13.6666 10.9173Z"}));
}

Phone.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Phone;

Phone.default = Phone;
